import type { ContextualBiddingInterface } from 'sonata-static-storage/lib/schemas/campaign/contextualBidding.schema';
import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getContextualBiddingTags(contextualBidding: ContextualBiddingInterface<any>, goal: number): TagItem[] {
  if (!contextualBidding?.enabled) {
    return [];
  }
  const result: TagItem[] = [];
  const activeScenarios = contextualBidding.scenarios.filter(s => !s.removed).length;
  if (activeScenarios > 0) {
    result.push({ label: `${activeScenarios} context${activeScenarios !== 1 ? 's' : ''}` });
  }
  if (contextualBidding.distribution?.enabled) {
    const distValue = contextualBidding.distribution.value;
    if (distValue === 0) {
      result.push({ label: 'All With Context' });
    } else if (distValue === goal) {
      result.push({ label: 'No Context' });
    } else {
      result.push({ label: 'Balanced' });
    }
  }

  return result;
}
